var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "datepicker-button-section" },
    [
      _c("button", {
        directives: [
          {
            name: "shortkey",
            rawName: "v-shortkey",
            value: _vm.previousShortKeyConf,
            expression: "previousShortKeyConf"
          }
        ],
        staticClass:
          "datepicker-button-section__previous button icon icon-leftarrow",
        attrs: {
          "aria-label": _vm.previousLabel,
          title: _vm.previousLabel,
          type: "button"
        },
        on: {
          click: _vm.navigateToPreviousTimeRange,
          shortkey: _vm.navigateToPreviousTimeRange
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "datepicker-button-section__datepicker-label button datepicker-label",
          on: {
            click: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.toggleDatepicker($event)
            },
            mousedown: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.doNothing($event)
            },
            mouseup: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.doNothing($event)
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm._f("formatDateRage")(_vm.selectedDate, _vm.view, _vm.locale)
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c("DatePicker", {
        ref: "datepicker",
        staticClass: "datepicker-button-section__datepicker",
        attrs: {
          date: _vm.selectedDate,
          "is-all-day": true,
          open: _vm.isDatepickerOpen
        },
        on: {
          "update:open": function($event) {
            _vm.isDatepickerOpen = $event
          },
          change: _vm.navigateToDate
        }
      }),
      _vm._v(" "),
      _c("button", {
        directives: [
          {
            name: "shortkey",
            rawName: "v-shortkey",
            value: _vm.nextShortKeyConf,
            expression: "nextShortKeyConf"
          }
        ],
        staticClass:
          "datepicker-button-section__next button icon icon-rightarrow",
        attrs: {
          "aria-label": _vm.nextLabel,
          title: _vm.nextLabel,
          type: "button"
        },
        on: {
          click: _vm.navigateToNextTimeRange,
          shortkey: _vm.navigateToNextTimeRange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }